import React, { FC } from 'react';
import { createGlobalStyle } from 'styled-components';

interface BaseLayoutProps {
  children: React.ReactNode;
}

export const GlobalStyles = createGlobalStyle`
  html {
    font-size: 16px; // basis of the rem unit for all other references
  }
  
  html div,body div, p, h1, h2, h3, h4, h5, h6, a, span, input, button, label, textarea {
    font-family: "Roboto", "Open Sans", Helvetica, sans-serif !important;
  }
  h1,h2,h3,h4,h5,h6 {
    margin: 0;
    line-height: 1.5;
  }

  h1 {
    font-size: ${props => props.theme.heading1Size};
  }

  h2 {
    font-size: ${props => props.theme.heading2Size};
    margin: 0;
    line-height: 1;
  }
  
  h3 {
    font-size: ${props => props.theme.heading3Size};
  }

  h4 {
    font-size: ${props => props.theme.heading4Size};
  }

  h5 {
    font-size: ${props => props.theme.heading5Size};
  }
  
  p, label {
    font-size: ${props => props.theme.paragraphSize};
  }

  p, label, span, a {
    line-height: 1.43
  }
  
  body {
    background: white;
  }
 
  // This is a fix for random img elements that get added to the DOM by various
  // tracking scripts which cause vertical scrolling when they shouldn't.
  body > img {
    display: none;
    margin: 0;
    padding: 0;
  }
`;

export const BaseLayout: FC<BaseLayoutProps> = props => {
  return (
    <>
      <GlobalStyles />
      {props.children}
    </>
  );
};
